<template>
  <v-list-item class="px-0">
    <v-list-item-title>{{ label }}:</v-list-item-title>
    <div
      :class="[
        inputClass,
        'text--darken-3 body-2',
        { 'text-grey': inputClass.indexOf('text') === -1 },
      ]"
    >
      {{ value }}
      <slot />
    </div>
  </v-list-item>
</template>

<script>
export default {
  props: {
    inputClass: { type: String, default: '' },
    label: { type: String, required: true },

    value: { default: '' },
  },
}
</script>
